interface ISong {
    artist: string
    title?: string
}

class Song implements ISong {
    artist = ''
    title? = ''

    constructor (artist = '', title: string | undefined = undefined) {
        this.artist = artist
        this.title = title
    }

    public toString (): string {
        if (this.title !== undefined && this.title !== '') {
            return `${this.artist} - ${this.title}`
        } else {
            return `${this.artist}`
        }
    }
}

export {
    ISong, Song
}
